import React from 'react';
import ActionCard from '../jo-components/cards/actionCard/actionCard';
import { APIAction } from '../order-menu/api-action/api-action';
import { Box } from '../ui';
import EmptyState from '../jo-components/misc/emptyState/emptyState';
import ItemCard from '../jo-components/cards/itemCard/itemCard';
import ItemCardInfos from '../jo-components/cards/itemCard/components/itemCardInfos/itemCardInfos';
import Message from '../jo-components/misc/message/message';
import NeoLayout from '../neoLayout';
import { useTranslation } from 'react-i18next';
import './waitingListTicketMenu.css';
import '../jo-components/cards/actionCard/actionCard.css';


export function WaitingListTicketMenu({ config, onSubmit=()=>{}, storage }) {
    const { t } = useTranslation();
    const menu = config['waiting_list_menu'];
    const { display_unavailable_actions = false } = menu.settings || [];
    const waitingTicket = menu['waiting_list_ticket'];
    const actions = menu?.actions?.filter(action => action.enabled || display_unavailable_actions);

    const actionType = (iconName) => {
        switch(iconName) {
            case 'cross':
                return 'delete';
            case 'edit':
                return 'inverted';
            case 'check':
            case 'checkSimple':
                return 'confirm';
            default:
                return 'primary';
        }
    };

    const actionSize = (iconName) => {
        switch(iconName) {
            case 'cross':
            case 'check':
            case 'checkSimple':
                return 'huge';
            default:
                return 'regular';
        }
    };

    return (
		<Box className="wz-waiting-list-menu-step">
            <div className="neo-title-subtitle">
			    <NeoLayout.Header config={{title: menu.title}} />
			    <NeoLayout.Subtitle config={{subtitle: menu.subtitle}} />
            </div>
            <ItemCard
                status={waitingTicket.status}
                title={waitingTicket.rate_name}
                subtitle={waitingTicket.event_name}
            >
                <ItemCardInfos title={waitingTicket.informations_title} informations={waitingTicket.informations} />
            </ItemCard>
            {menu?.messages?.map((message, index) => (
                <Message key={index} {...message} />
            ))}
            <div className="wz-menu-content">
                <div className="neo-title-subtitle">
                    <NeoLayout.Header config={{title: menu.actions_title}} />
                </div>
                {!actions?.length && <EmptyState title={t('widget.empty.actions.title')} subtitle={t('widget.empty.actions.subtitle')} icon="list" />}
                {actions?.map((action, index) => (
                    <APIAction key={index} name={action.type} actions={actions}>
                        <ActionCard
                            {...action}
                            size={actionSize(action.icon)}
                            type={actionType(action.icon)}
                            icon={action.icon}
                            disabled={!action.enabled}
                            onClick={() => {
                                onSubmit({
                                    data: {
                                        action: action.type,
                                        payload: {
                                            waiting_list_ticket_id: waitingTicket.id
                                        }
                                    }
                                })
                            }}
                        />
                    </APIAction>
                ))}
            </div>
		</Box>
	)
}
